export default "__VITE_ASSET__DLwAKire__"